import { STORE_USER_DETAILS, CLEAR_USER_DETAILS } from "../actions";

export function storeUserDetails(payload) {
  return {
    type: STORE_USER_DETAILS,
    payload
  };
}

export function clearUserDetails(payload) {
  return {
    type: CLEAR_USER_DETAILS
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/userDetails.js